import {observable} from 'mobx';


class Prompt {
  @observable open = false;
  @observable content = '';
  @observable time = 1500;
  message(content,time=1500){
    this.default();
    this.content = content;
    this.time = time
    this.open = true;
  }
  default(){
    this.open = false;
    this.content = '';
  }
}
var prompt = new Prompt;

export default prompt;



// WEBPACK FOOTER //
// ./src/store/prompt.js